import resolveConfig from 'tailwindcss/resolveConfig';

export const tailwindConfig = () => {
  // Tailwind config
  return resolveConfig('./src/css/tailwind.config.js')
}

export const jsonColorizer = {
  /**
   * Replacer for the json text
   */
  replacer: function (match, pIndent, pKey, pVal, pEnd) {
    const key = "<span class=json-key>";
    const num = "<span class=json-number>";
    const str = "<span class=json-string>";
    const bool = "<span class=json-boolean>";
    let r = pIndent || "";

    //A key
    if (pKey) r = r + key + pKey.replace(/[": ]/g, "") + "</span>: ";
    //A value type boolean
    if (pVal == "true" || pVal == "false") r = r + bool + pVal + "</span>";
    //A number value
    else if (!isNaN(pVal)) r = r + num + pVal + "</span>";
    //A string value
    else if (pVal) r = r + str + pVal + "</span>";

    return r + (pEnd || "");
  },

  /**
   * Returns a formatted text.
   * @param {Object} json to print.
   * @param {spaces} number of spaces (default: 2)
   */
  prettyPrint: function (json, spaces = 2) {
    const text = JSON.stringify(json, null, spaces);
    const jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/gm;
    return text
      .replace(/&/g, "&amp;")
      .replace(/\\"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(jsonLine, jsonColorizer.replacer);
  }
}

export const hexToRGB = (h) => {
  let r = 0;
  let g = 0;
  let b = 0;
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }
  return `${+r},${+g},${+b}`;
};

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    }
    : null;
};

export const formatValue = (value) => Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumSignificantDigits: 3,
  notation: 'compact',
}).format(value);

export const formatThousands = (value) => Intl.NumberFormat('en-US', {
  maximumSignificantDigits: 3,
  notation: 'compact',
}).format(value);

// ***----------------------------------*** //
// ***----------------------------------*** //

// Sets an item with a Key to local storage
export const saveStorage = function (key, data) {
  data = (typeof data === 'string')
    ? data
    : JSON.stringify(data)
  localStorage.setItem(key, data);
};

// Looks for a local storage item and returns if present
export const getStorage = function (key, item) {
  if (localStorage.getItem(key) && item) {
    const data = JSON.parse(localStorage.getItem(key))
    return data[item]
  }
  else if (localStorage.getItem(key)) {
    return localStorage.getItem(key)
  }
};

// Clear a single item or the whole local storage
export const clearStorage = function (key = 'false') {
  if (key) {
    localStorage.removeItem(key);
  } else {
    localStorage.clear();
  }
};


// ***----------------------------------*** //
// ***----------------------------------*** //


// Transform les ID de flight en quelque chose de lisible pour d'autre fonction
export const deconcat = function (str) {
  var regex = /(.*)[-_](.*)/gm;
  return regex.exec(str);
};

// Retourne l'ID du flight
export const idFlight = function (str) {
  return deconcat(str)[1];
};

// Retourne la date du flight
export const dateFlight = function (str) {
  let m = deconcat(str);

  let years = m[2].slice(0, 4);
  let month = m[2].slice(4, 6);
  let day = m[2].slice(6, 8);
  let hours = m[2].slice(8, 10);
  let minute = m[2].slice(10, 12);
  let seconde = m[2].slice(12, 14);

  return {
    date: day + "/" + month + "/" + years,
    heure: hours + ":" + minute + ":" + seconde
  }
};

// Transforme une date texte de flight en timestamp
export const timestampFlight = function(str) {
  let m = deconcat(str);

  let years = m[2].slice(0, 4);
  let month = m[2].slice(4, 6);
  let day = m[2].slice(6, 8);

  let newDate = new Date(`${years}-${month}-${day}`);

  return newDate.getTime() / 1000;
}

export const timestampDJI = function(str) {
  // exp : '2024-03-12 14:18:45.384094'
  let years = str.slice(0, 4);
  let month = str.slice(5, 7);
  let day = str.slice(8, 10);
  let hours = parseInt(str.slice(11, 13)) + parseInt(new Date().getTimezoneOffset() / -60) ;
  let minute = str.slice(14, 16);
  let seconde = str.slice(17, 19);
  let dd = new Date(years, month-1, day, hours, minute, seconde);
  // console.log(str, {
  //   'years': years,
  //   'month': month,
  //   'day': day,
  //   'hours': hours,
  //   'minute': minute,
  //   'seconde': seconde
  // });
  // console.log(dd);
  return dd.getTime();
}

export const dateDJI = function(str) {
  // exp : '2024-03-12 14:18:45.384094'
  let years = str.slice(0, 4);
  let month = str.slice(5, 7);
  let day = str.slice(8, 10);
  let hours = parseInt(str.slice(11, 13)) + parseInt(new Date().getTimezoneOffset() / -60);
  let minute = str.slice(14, 16);
  let seconde = str.slice(17, 19);
  let dd = new Date(years, month - 1, day, hours, minute, seconde);

  return {
    date: day + "/" + month + "/" + years,
    heure: hours + ":" + minute + ":" + seconde
  }
}

export const isNoFlightZone = function(name) {
  const regex = new RegExp(ENV.NO_FLIGHT_ZONE);
  return regex.exec(name) != null;
}

export const getFlightZoneName = function(name) {
  return name
    .replace(ENV.NO_FLIGHT_ZONE, '')
    .replace(ENV.FLIGHT_ZONE, '')
}

export const dirDate = function (str) {
  if(str.length == 8) {
    // transforme une date au format "YYYYMMDD" en "DD-MM-YYYY"
    const year = str.substring(0, 4);
    const month = str.substring(4, 6);
    const day = str.substring(6, 8);
    return `${day}/${month}/${year}`;
  }
  else {
    // transforme une date au format "YYYYMMDDHHIISS" en "DD-MM-YYYY HH:II:SS"
    const year = str.substring(0, 4);
    const month = str.substring(4, 6);
    const day = str.substring(6, 8);
    const hours = str.substring(8, 10);
    const min = str.substring(10, 12);
    const sec = str.substring(12, 14);

    return `${day}/${month}/${year} ${hours}:${min}:${sec}`;
  }
  return '';
}

export const deviceDate = function (str) {
  // 2023-05-11T07:16:54.971839 -> 11/05/2023 07:16:54
  const year = str.substring(0, 4);
  const month = str.substring(5, 7);
  const day = str.substring(8, 10);
  const hours = str.substring(11, 13);
  const min = str.substring(14, 16);
  const sec = str.substring(17, 19);

  return `${day}/${month}/${year} ${hours}:${min}:${sec}`;
}


// ***----------------------------------*** //
// ***----------------------------------*** //

export const stateFlight2Color = function(state) {
  switch (state) {
    case "Init":
      return 'g4';
      break;
    case "Terminée avec succès" :
      return 'success';
      break;
    case "En cours":
      return 'success animate-pulse';
      break;
    case "Terminée (erreur)" :
      return "error";
      break;
    default:
      return 'g4';
      break;
  }

}

export const transformDeviceTimeToText = function(number) {
  if (number > ENV.DEVICE_OFFLINE) {
    return $root.$e("Hors ligne");
  } else if (number >= 1000) {
    return (number / 1000).toFixed(2) + " s";
  } else {
    return number + " ms";
  }
}

export const colorTextLastTimeStatus = function (lastStatus) {
  if (lastStatus < 2000) {
    return "text-success fill-success";
  }
  if (lastStatus < 3000) {
    return "text-warning fill-warning";
  }
  return "text-error fill-error";
}

export const RcPlusColorTextLastTimeStatus = function (lastStatus) {
  if (lastStatus < 6500) {
    return "text-success fill-success";
  }
  if (lastStatus < 8500) {
    return "text-warning fill-warning";
  }
  return "text-error fill-error";
}

export const droneStateColor = function(droneStatut, LastDroneStatus) {
  if (LastDroneStatus > ENV.DEVICE_OFFLINE) {
    return "error";
  }

  switch (droneStatut) {
    /** ---- */
    case 0: // 0: "Standby",
    case 2: // 2: "Fin de la préparation au décollage",
    case 3: // 3: "Vol manuel",
    case 4: // 4: "Décollage automatique",
    case 5: // 5: "Vol en ligne",
    case 6: // 6: "Prise de vue panoramique"
    case 7: // 7: "Suivi intelligent",
    case 9: // 9: "Retour automatique",
    case 10: // 10: "Atterrissage automatique",
    case 15: // 15: "Système avancé d'aide au pilotage - APAS"
    case 16: // 16: "Pilotage virtuel"
    case 17: // 17: "Commandes de vol en court d'execution"
    case 18: // "Airborne RTK fixing mode",
    case 19: // "Dock address selecting",
    case 20: // "POI",
      return "success";
    /** ---- */

    case 1: // 1: "Préparation au décollage",
    case 8: // 8: "Évitement ADS-B",
    case 12: // 12: "Atterrissage à trois pales",
    case 13: // 13: "Mise à niveau",
      return "warning";

    /** ---- */
    case 11: // 11: "Atterrissage forcé",
    case 14: // 14: "Pas de connexion",
      return "error";

    /** ---- */
    default:
      return "g4";
  }
}

export const parachuteStateColor = function (parachuteStatut, LastParachuteStatus) {
  if (LastParachuteStatus > ENV.DEVICE_OFFLINE) {
    return "error";
  }

  if (parachuteStatut == 1) {
    return "success";
  }
  else if (parachuteStatut == 0) {
    return "error";
  }
  else {
    return "warning";
  }
}

export const dockStateColor = function (dockStatut, LastDockStatus) {
  if (LastDockStatus > ENV.DEVICE_OFFLINE) {
    return "error";
  }

  switch (dockStatut) {
    case 0:
      return "success";

    case 1:
    case 2:
      return " debug-dock";

    case 3:
      return "error";

    case 4:
      return "success";

    case 5:
      return "warning";

    default:
      return "g4";
  }
}

export const rcPlusStateColor = function (LastRcPlusStatus) {
  if (LastRcPlusStatus > ENV.DEVICE_OFFLINE) {
    return "error";
  }
  return "success";
}

export const dockStateColorText = function(dockStatut, LastDockStatus) {
  if (LastDockStatus > ENV.DEVICE_OFFLINE) {
    return "text-error";
  }

  /**
   * "0": "Inactif",
   * "1": "Débogage sur site",
   * "2": "Débogage à distance",
   * "3": "Mise à niveau du logiciel",
   * "4": "En fonctionnement",
   * "14": "Déconnecter"
   */

  switch (dockStatut) {
    case 0:
      return "text-success";
    case 14:
      return "text-error";
    case 1:
    case 2:
    case 3:
      return "text-warning";
    case 4:
      return "text-success";
    default:
      return "text-warning";
  }
}

export const rcPlusStateColorText = function (LastRcPlusStatus) {
  if (LastRcPlusStatus > ENV.DEVICE_OFFLINE) {
    return "error";
  }
  return "success";
}

export const netQualityColor = function (netQuality) {
  /* {
      "0":"No signal",
      "1":"Poor",
      "2":"Poor",
      "3":"Moderate",
      "4":"Better",
      "5":"Good"
  } */

  switch (netQuality) {
    case 0:
      return "error";
    case 1:
    case 2:
    case 3:
      return "warning";
    case 4:
    case 5:
      return "success";
    default:
      return "g4";
  }
}


// ***----------------------------------*** //
// ***----------------------------------*** //

export const StartConfigDevice = function (device, Device_App) {
  let config = {
    deviceFamilly   : device,
    loaded          : false,
    reduce          : false,
    qrCodeOpen      : false,
    settingOpen     : false,
    dock            : false,
    rcPlus          : false,
    drone           : false,
    webcam          : false,
    parachute       : false,
    router: false,
    FlightInit: false,
    infoType: 'small',

    // --
    ActionPopup: false,
    // ---
    videos          : [],
    map             : {},
    // ---
    methods: {
      LoadVideo : Device_App.LoadVideo,
      CloseVideo : Device_App.CloseVideo,
      ToggleVideo : Device_App.ToggleVideo,
      ReloadVideo : Device_App.ReloadVideo,
      OpenPopup : Device_App.OpenPopup,
      OpenPopupOnCurrentPage : Device_App.OpenPopupOnCurrentPage,
    },
    HMS: {
      errorHMS: {
        dock:[],
        drone:[]
      },
      open: false,
    },
    flight: {
      id: null,
      flg_id: null,
      mis_id: null,
      info: {},
      status: {},
      openControlPanel: false,
    },
    camera: {
      payload_index: 0,
      array_index: 0,
      status: {},
    },
    // ---
    // ---
  };

  if (device?.router_dev_id) {
    config.router = {
      id: device.router_dev_id,
      name: device.router_name,
      det: device.router_det_id,
      methods: {},
    };
  }
  // ---
  if (device?.dock_dev_id) {
    config.dock = {
      id: device.dock_dev_id,
      name: device.dock_dev_name,
      det: device.dock_det_id,
      methods: {},
    };
  }
  if (device?.rc_dev_id) {
    config.rcPlus = {
      id: device.rc_dev_id,
      name: device.rc_dev_name,
      det: device.rc_det_id,
      methods: {},
    };
  }
  if (device?.drone_dev_id) {
    config.drone = {
      id: device.drone_dev_id,
      name: device.drone_name,
      det: device.drone_det_id,
      methods: {},
    };
  }
  // ---
  if (device?.webcam_dev_id) {
    config.webcam = {
      id: device.webcam_dev_id,
      name: device.webcam_name,
      det: device.webcam_det_id,
      methods: {},
    };
  }
  if (device?.parachute_dev_id) {
    config.parachute = {
      id: device.parachute_dev_id,
      name: device.parachute_name,
      det: device.parachute_det_id,
      methods: {},
    };
  }

  return config;
}


// ***----------------------------------*** //
// ***----------------------------------*** //

export const StartVideoResult = function (result, type) {
  // GENERAL =================
  if (
    result == 0 ||
    result == 613011
  ) {
    return true;
  }
  // OFF ======================
  if (type == "off" && (
    result == 513001 ||
    result == 513011
  )) {
    return true;
  }
  // ON =======================
  if (type == "on" && (
    result == 513003
  )) {
    return true;
  }
  // OPTION ===================
  if(type == "option" && (
    result == 513011
  )) {
    return true;
  }
  return false;
}

export const copyObject = function (obj){
  const deepCopy = JSON.parse(JSON.stringify(obj));
  return deepCopy;
}

export const secondToUltraText = function (second) {
  // faire en fonctione de si Jour, Heure, Minute, Seconde

  if(second < 60) {
    return second + "s";
  }
  else if(second < 3600) {
    return Math.floor(second / 60) + "m " + second % 60 + "s";
  }
  else if(second < 86400) {
    return Math.floor(second / 3600) + "h " + Math.floor((second % 3600) / 60) + "m";
  }
  else {
    return Math.floor(second / 86400) + $root.$e("j") + " " + Math.floor((second % 86400) / 3600) + "h";
  }
}
